// src/pages/vendor/Settings/index.tsx

import React, { useState } from 'react';
import { User, MapPin, Store, Shield } from 'lucide-react';
import GeneralSettings from './GeneralSettings';
import PickupAddressSettings from './PickupAddressSettings';
import { useVendor } from '../../../hooks/useVendor';

const VendorSettingsPage: React.FC = () => {
    const [activeTab, setActiveTab] = useState('general');
    const { vendor, loading, refetch } = useVendor();

    const tabs = [
        { id: 'general', label: 'General', icon: User },
        { id: 'addresses', label: 'Pickup Addresses', icon: MapPin },
        { id: 'store', label: 'Store Settings', icon: Store },
        { id: 'security', label: 'Security', icon: Shield },
    ];
    
    return (
        <div className="p-6 max-w-4xl mx-auto">
            <h1 className="text-2xl font-bold text-gray-900 mb-6">Settings</h1>

            <div className="border-b border-gray-200 mb-6">
                <nav className="flex gap-6">
                    {tabs.map((tab) => (
                        <button
                            key={tab.id}
                            onClick={() => setActiveTab(tab.id)}
                            className={`p-3 px-1 pl-2 pr-2 text-sm font-medium border-b-2 transition-colors ${
                                activeTab === tab.id
                                    ? 'border-blue-600 text-blue-600'
                                    : 'border-transparent text-gray-500 hover:text-gray-700'
                            }`}
                        >
                            <tab.icon className="inline-block h-4 w-4 mr-2" />
                            {tab.label}
                        </button>
                    ))}
                </nav>
            </div>

            {activeTab === 'general' && <GeneralSettings vendor={vendor} onVendorUpdate={refetch}/>}
            {activeTab === 'addresses' && <PickupAddressSettings vendor={vendor} />}
            {/* Other tabs */}
        </div>
    );
};

export default VendorSettingsPage;